import React, { Fragment } from "react";
import { any, func, string, bool } from "prop-types";
import * as style from "./styles.module.scss";
import ProfileItem from "../ProfileItem";

const ProfileSection = ({
  sections,
  onAddOrUpdate,
  titleText = "",
  isIncomplete = false,
  className = "",
  children = null,
}) => (
  <div className={`container bg-grey ${className}`}>
    <div className="pb-1 pb-lg-2 mt-2 bg-grey">
      <h3 className={style.profile__incompleteItems_wrapper}>{titleText}</h3>
      {sections && sections.length > 0 && !children ? (
        <Fragment>
          <div
            className={
              isIncomplete
                ? style.profile__incompleteItems
                : style.profile__incompleteItems_complete
            }
          >
            {sections.map((section) => (
              <ProfileItem
                key={section.id}
                onAddOrUpdate={onAddOrUpdate}
                item={section}
                isIncomplete={isIncomplete}
              />
            ))}
          </div>
        </Fragment>
      ) : (
        children
      )}
    </div>
  </div>
);

ProfileSection.propTypes = {
  sections: any,
  onAddOrUpdate: func,
  titleText: string,
  isIncomplete: bool,
  className: string,
  children: any,
};

export default ProfileSection;
